export function BMICalculate(weight, height) {
  return weight / Math.pow(height, 2);
}

export function my_storage(storage_key, field) {
  let a = JSON.parse(sessionStorage.getItem(storage_key));
  if (!a) a = [];
  return typeof a[field] !== "undefined" ? a[field] : "";
}

export function arr_unique(array) {
  return array.filter(function(el, index, arr) {
    return index == arr.indexOf(el);
  });
}

export function my_range(start, stop) {
  return new Array(stop - start).fill(start).map((n, i) => n + i);
}

export function getCurrentStep(step) {
  return sessionStorage.getItem(step);
}

export function incCurrentStep(step, num) {
  sessionStorage.setItem(step, num);
}
